import script from "./EmpHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmpHome.vue?vue&type=script&setup=true&lang=ts"

import "./EmpHome.vue?vue&type=style&index=0&id=be69df7c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be69df7c"]])

export default __exports__